import React, { Fragment } from 'react';
import HomeComponent from '../../components/HomeComponent';
/* import Grid from '../../components/Grid';
 */
const Home: React.FC = () => (
   <Fragment>
      {/* <Grid /> */}
      <HomeComponent />
   </Fragment>
 );

export default Home;


